export const EMPTY_LIST_PLACEHOLDER_BASE = 'You haven’t added any picks yet.';
export const EMPTY_LIST_PLACEHOLDER_FOR_CREATOR = `${EMPTY_LIST_PLACEHOLDER_BASE} Get started with the plus icon in the tab bar below.`;
export const EMPTY_LIST_PLACEHOLDER_FOR_VIEWER = 'This list is empty. Watch this space.';
